module.exports = __webpack_public_path__ + "static/media/brain.a5a036c3.svg";